// extracted by mini-css-extract-plugin
export default {"container":"P1yqPyT7SJ6ZEpVSLmVE"};